export default [{
	"redirect": null,
	"path": "/superuser",
	"component": () =>
    import ('@/components/superUser/cUser.vue'),
	"route": "1",
	"meta": {
		"keepAlive": "true",
		"title": "用户管理"
	},
	"name": "用户管理-系统管理员",
	"id": "ad885588e0c27644767e5cfdace99563",
	"hasChildrenShow": "0"
}, {
	"redirect": "/accountmanagement/list",
	"path": "/accountmanagement",
	"component": () =>
    import ('@/components/superUser/accountmanagement.vue'),
	"route": "1",
	"children": [{
		"redirect": null,
		"path": "/accountmanagement/list",
		"component": () =>
        import ('@/components/superUser/accountmanagementList.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "帐号管理"
		},
		"name": "帐号管理列表",
		"id": "fe4c1229419206354eac55f050279c4a",
		"hasChildrenShow": "0"
	}, {
		"redirect": null,
		"path": "/accountmanagement/infor",
		"component": () =>
        import ('@/components/superUser/accountmanagementInfor.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "帐号管理"
		},
		"name": "帐号详情",
		"id": "a3b5538c8b3456b2de066109cea9e043",
		"hasChildrenShow": "0"
	}, {
		"redirect": null,
		"path": "/accountmanagement/creat",
		"component": () =>
        import ('@/components/superUser/accountmanagementCreat.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "帐号管理 / 新建用户"
		},
		"name": "新建帐号",
		"id": "20a9b032a244bbf5dd20a3d7e8b4721c",
		"hasChildrenShow": "0"
	}, {
		"redirect": null,
		"path": "/accountmanagement/othercreat",
		"component": () =>
        import ('@/components/superUser/accountmanagementCreat.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "帐号管理 / 新建独立经纪人帐号"
		},
		"name": "新建独立经纪人",
		"id": "92ece39f20b89cedd69ba0542d39272f",
		"hasChildrenShow": "0"
	}],
	"meta": {
		"keepAlive": "true",
		"title": "帐号管理"
	},
	"name": "帐号管理-系统管理员",
	"id": "a5740cca58c9b09f78a18a0a42e2b7e8",
	"hasChildrenShow": "0"
}, {
	"redirect": "/role/list",
	"path": "/role",
	"component": () =>
    import ('@/components/superUser/roleIndex.vue'),
	"route": "1",
	"children": [{
		"redirect": null,
		"path": "/role/list",
		"component": () =>
        import ('@/components/superUser/roleList.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "角色管理"
		},
		"name": "角色管理列表",
		"id": "681809a44321b61851a674cfcdacf536",
		"hasChildrenShow": "0"
	}, {
		"redirect": null,
		"path": "/role/creat",
		"component": () =>
        import ('@/components/superUser/roleCreat.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "角色管理 / 新建角色"
		},
		"name": "新建角色",
		"id": "77945c2040074dc78fac04d22bc2e9b0",
		"hasChildrenShow": "0"
	}, {
		"redirect": null,
		"path": "/role/edit",
		"component": () =>
        import ('@/components/superUser/roleCreat.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "角色管理 / 修改角色"
		},
		"name": "修改角色",
		"id": "3ca1be2851eeecb6d42b361096dfcceb",
		"hasChildrenShow": "0"
	}, {
		"redirect": null,
		"path": "/role/look",
		"component": () =>
        import ('@/components/superUser/roleCreat.vue'),
		"route": "1",
		"hidden": true,
		"meta": {
			"keepAlive": "true",
			"title": "角色管理 / 查看角色"
		},
		"name": "查看角色",
		"id": "4bb37f95c1b1b43bfacbe264a1154b8f",
		"hasChildrenShow": "0"
	}],
	"meta": {
		"keepAlive": "true",
		"title": "角色管理"
	},
	"name": "角色管理",
	"id": "acd8b55619d020ceebce9098bb112202",
	"hasChildrenShow": "0"
}]